import { MenuItem, TextField } from '@material-ui/core'
import React from 'react'
import { CARRIER_PROVIDERS } from '../../root/constants'
import { makeStyles } from '@material-ui/core/styles'
import { useSelector } from 'react-redux'

export default function HotSwapDropdownCarrier({ value, onItemChange }) {
    const classes = useStyles()
    const { locale } = useSelector(state => state.main)

    return (
        <TextField
            hiddenLabel
            className={classes.dropdown}
            value={value}
            select>
            {CARRIER_PROVIDERS.map((item, index) => {
                return (
                    <MenuItem
                        key={index}
                        onClick={() => onItemChange(item)}
                        value={item}>
                        {item}
                    </MenuItem>
                )
            })}
        </TextField>
    )
}

const useStyles = makeStyles(theme => ({
    dropdown: {
        width: '100px'
    }
}))
